module.exports = __webpack_public_path__ + "4445bf64252f88dfd6972a68951c7ffd.png";